
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.038 31.29l4.376-4.376c1.056-1.056.622-2.86-.802-3.318L36 22.756V14a2 2 0 00-2-2h-4V9.5A1.5 1.5 0 0028.5 8h-9A1.5 1.5 0 0018 9.5V12h-4a2 2 0 00-2 2v8.756l-2.612.84c-1.422.457-1.86 2.26-.802 3.318l4.375 4.376C11.864 34.018 9.35 36 5.5 36A1.5 1.5 0 004 37.5v1A1.5 1.5 0 005.5 40c3.814 0 6.719-1.288 8.954-3.712A6.01 6.01 0 0020 40h8a6.01 6.01 0 005.546-3.712C35.781 38.712 38.686 40 42.5 40a1.5 1.5 0 001.5-1.5v-1a1.5 1.5 0 00-1.5-1.5c-3.801 0-6.346-1.938-7.462-4.71zM16 16h16v5.47l-7.388-2.374a2 2 0 00-1.224 0L16 21.471V16z","fill":"#535353"}})])
          )
        }
      }
    